export class WFParametersDto {
    communityId: number; // 	NOTE: Required for most endpoints of workflow editor except for getting communities, workflow history and downloading invoice
    clearCache = false;

    getQueryString(): string {
        return `?communityId=${this.communityId}&clearCache=${this.clearCache}`;
    }
}
